import { isBrowser } from './utils';

export function setValuesToSessionStorage<TValues>(key: string, values: TValues): void {
  if (!isBrowser()) {
    return;
  }

  try {
    const value = JSON.stringify(values);
    window.sessionStorage.setItem(key, value);
  } catch (err) {
    // Swallow
  }
}
